var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-doc"},[_c('documentation-container',{attrs:{"title":_vm.title}},[_c('template',{slot:"content"},[_c('div',{staticClass:"content-progress"},[_c('progress-bar',{attrs:{"width":20}})],1)])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }